import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../Redux/Actions/actions';
import CardUserContainer from '../../Components/CardUserContainer/CardUserContainer';

const ListUser = () => {
  const dispatch = useDispatch();
  const { users, usersTotal, usersLoading, usersError } = useSelector(state => state);
  const gym = useSelector(state => state.gym);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (gym?.id) {
      dispatch(getUsers(gym.id, search));
    }
  }, [dispatch, gym, search]);

  return (
    <div>
      <h2>Lista de Socios</h2>
      <input
        type="text"
        placeholder="Buscar por DNI, nombre o apellido..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ marginBottom: '1rem', padding: '0.5rem', width: '100%', maxWidth: 400 }}
      />
      <div style={{ marginBottom: '1rem' }}>
        <strong>Total:</strong> {usersTotal}
      </div>
      {usersLoading && <p>Cargando socios...</p>}
      {usersError && <p style={{ color: 'red' }}>{usersError}</p>}
      <CardUserContainer users={users} />
    </div>
  );
};

export default ListUser;